import { Container } from './styles'

export default function AdminPedidos() {
  return (
    <Container>
      <div>
        <h2>PEDIDOS</h2>
        <div>
          <table>
            <thead>
              <tr>
                <th>Pedido</th>
                <th>Usuário</th>
                <th>Data</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>wjbdqwjkcb</td>
                <td>Joao Pessoa</td>
                <td>20/06/23</td>
                <td>Pendente</td>
              </tr>
              <tr>
                <td>wjbdqwjkcb</td>
                <td>Frenado Souza</td>
                <td>20/06/23</td>
                <td>Entregue</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Container>
  )
}
